
import React, { createContext, useContext } from 'react';

interface AuthContextType {
    session: any | null;
    user: any | null;
    profile: any | null;
    loading: boolean;
    refreshProfile: () => Promise<void>;
    signOut: () => Promise<void>;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export function AuthProvider({ children }: { children: React.ReactNode }) {
    // Constant values for guest mode
    const session = null;
    const user = null;
    const profile = null;
    const loading = false;

    const refreshProfile = async () => {};
    const signOut = async () => {};

    return (
        <AuthContext.Provider value={{ session, user, profile, loading, refreshProfile, signOut }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    const context = useContext(AuthContext);
    if (context === undefined) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
}
